export enum SignType {
  Combo = 'combo',
  UserIdOnly = 'user_id_only',
}
